import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcInvitationSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29 5v18H13.714v-2H27V7.92l-9 6.3-9-6.299V14H7V5h22ZM12 20v2H4v-2h8Zm0-4v2H2v-2h10Zm12.826-9H11.173L18 11.779 24.826 7ZM12 24v2H6v-2h6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcInvitationSend;
